// extracted by mini-css-extract-plugin
export default {"CancelButton":"CancelButton_CancelButton__Xi80I","CancelButton--rounded":"CancelButton_CancelButton--rounded__-861U"};